module.exports = __webpack_public_path__ + "img/azureaks-black.c476b248.svg";